module.exports = __webpack_public_path__ + "static/media/Somewhere-Up-North.a597d9fb.jpg";